import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Accordion } from '@totalsoft/rocket-ui';

import FinancedOffersAssetItemComponentV2 from './FinancedOffersAssetItemComponentV2';
import FinancedOfferItemComponentSummary from './FinancedOfferItemComponentSummary';
import PropTypes from 'prop-types';

export const FinancedOffersListItemComponentV2 = ({
  t,
  financedOffer,
  openFinancedOffer,
  openOfferAsset,
  selectAssetsForContractGeneration,
  key
}) => {
  return (
    <Accordion
      defaultExpanded={true}
      key={key}
      title={<FinancedOfferItemComponentSummary financedOffer={financedOffer} openFinancedOffer={openFinancedOffer} />}
      content={
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('Document.ContractGeneration.Selected')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.AssetName')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.PriceWithVAT')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.Dealer')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {financedOffer.assets.map((asset, key) => {
                return (
                  <FinancedOffersAssetItemComponentV2
                    key={key}
                    asset={asset}
                    offerId={financedOffer.offerId}
                    offerSiteId={financedOffer.offerSiteId}
                    openOfferAsset={openOfferAsset}
                    selectAssetsForContractGeneration={selectAssetsForContractGeneration}
                    selected={asset.selected}
                  />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      }
    />
  );
};

FinancedOffersListItemComponentV2.propTypes = {
  financedOffer: PropTypes.object.isRequired,
  openFinancedOffer: PropTypes.func.isRequired,
  openOfferAsset: PropTypes.func.isRequired,
  selectAssetsForContractGeneration: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  key: PropTypes.number
};

export default compose(withTranslation())(FinancedOffersListItemComponentV2);
